export const matchRoute = (pathnameApp, pathnameMenu) => {
  const normalize = (path = '/') => {
    // drop query / hash
    let p = path.split(/[?#]/)[0] || '/';

    // ensure leading slash
    if (!p.startsWith('/')) {
      p = '/' + p;
    }

    // remove trailing slashes except for root
    if (p.length > 1) {
      p = p.replace(/\/+$/, '');
    }

    return p;
  };

  const app = normalize(pathnameApp);
  const menu = normalize(pathnameMenu);

  // root tab: only active on real root
  if (menu === '/') {
    return app === '/';
  }

  // exact match (/campaigns) OR nested (/campaigns/create, /campaigns/123, etc.)
  return app === menu || app.startsWith(menu + '/');
};
